import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import CreditList, { DispatchProps, OwnProps, StateProps } from './CreditList';
import { StoreState } from 'src/store/reducers';
import { QueryParams } from 'src/types/grid';
import { getCredits } from 'src/store/actions/credit-actions';
import { getPayments } from 'src/store/actions/payment-actions';
import { selectNamePayments } from '../../../../../../store/selectors/payments-selectors';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        data: state.credits.data,
        payments: selectNamePayments(state),
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getData: (params: QueryParams) => dispatch(getCredits(params)),
        getPayments: (params: QueryParams) => dispatch(getPayments(params)),
    };
}

const CreditListScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(CreditList);

export default CreditListScreen;
